import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ForgotPassword } from "../../actions/LoginAction";
import swal from "sweetalert";

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const [formNumber, setFormNumber] = useState({value:'',error:''});
  const [loading,setLoading] = useState();
    const [showForm,setShowForm] = useState(true);
  const validation = () => {
    let formIsValid = true

    if (!formNumber.value) {
        formIsValid = false
        let msg = "Please Enter Your ALLEN Form Number"
        setFormNumber({...formNumber,error:msg})
    }

    if(formIsValid){
        setFormNumber({...formNumber,error:''})
    }
    return formIsValid
}


  const submitLoginHandler = async(e) => {
    e.preventDefault();

    if(validation()){

        const data = {
            form_no : formNumber.value
          };
          
          setLoading(true)
          try {
            await ForgotPassword(data).then((res) => {
              if(res.status){
                setLoading(false)
                setShowForm(false)
              }
              else{
                swal(res.message,'Try Again!','error')
                setLoading(false)
              }
            });
          } catch (error) {
            swal('Something went wrong!','',"error")
          }
    }
    
  };

  return (
    <>
    {showForm ?
       
    <form onSubmit={submitLoginHandler} className="w-100">
      <div className="mb-3">
        <label htmlFor="formNumber" className="form-label">
          ALLEN Form No.
        </label>
        <input
          type="text"
          className="form-control"
          id="formNumber"
          value={formNumber.value}
          onChange={(e) =>{
            let value = e.target.value
            value = value.replace(/\D/g, '')   
            setFormNumber({...formNumber,value:value,error:''})
        }}
          placeholder="Enter ALLEN form no."
        />
        {formNumber?.error.length > 0 && <small className="invalid-field text-danger fw-semibold mt-1">{formNumber.error}</small>}

      </div>

      <div className="mb-3">
        {/* <button type="submit" className="btn btn-primary d-block w-100">
          Login
        </button> */}
        {loading ? <button className="btn btn-primary w-100 d-block" disabled type="button">
                            <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                                Submitting please wait...</button> : 
                            <button className="btn btn-primary d-block w-100" type="submit">Submit</button>}
      </div>

    </form>
    : <div className="reset_message fw-bold">We have sent a password reset link to your registered email address. If you don't receive the email within a few minutes, 
    please check your spam folder. If you continue to experience issues, please contact our support team.</div>
}
</>
  );
};

export default ForgotPasswordForm;
